module.exports = __webpack_public_path__ + "static/media/ty-1.16c314f5.jpg";